import * as React from 'react'

import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { EmptyState } from 'modules/performance_feedbacks/components/EmptyState'

const PendingRequests = () => {
  return (
    <ResponsivePage.NestedBody>
      <EmptyState
        disabled
        title={i18n.t('performance_feedbacks.empty_state.pending_requests.title')}
        description={i18n.t('performance_feedbacks.empty_state.pending_requests.description')}
        buttonText={i18n.t('performance_feedbacks.empty_state.coming_soon')}
      />
    </ResponsivePage.NestedBody>
  )
}

export default PendingRequests
